var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "19px",
    viewBox: "0 0 8 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "hover-fill",
    id: "Sign-In",
    transform: "translate(-769.000000, -736.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M774.2755,742.728431 L774.2755,740.860068 C774.2755,740.158865 774.720095,739.995043 775.032938,739.995043 L776.95554,739.995043 L776.95554,736.91077 L774.308031,736.9 C771.368282,736.9 770.699763,739.200309 770.699763,740.672438 L770.699763,742.728431 L769,742.728431 L769,745.906235 L770.699763,745.906235 L770.699763,754.9 L774.2755,754.9 L774.2755,745.906235 L776.687699,745.906235 L777,742.728431 L774.2755,742.728431 Z",
    id: "Fill-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFIc);
export default __webpack_public_path__ + "static/media/f-ic.da656719fe81f324f28135b748eb58ca.svg";
export { ForwardRef as ReactComponent };